import { useEffect, useState } from "react";
import api, { getWorkspace } from "@/lib/api";

let cache = null;
let pending = null;
const listeners = new Set();

export function loadWorkspaces(force = false) {
  if (cache && !force) return Promise.resolve(cache);
  if (!pending) {
    pending = api.get("/workspaces").then((r) => {
      cache = r.data;
      pending = null;
      listeners.forEach((fn) => fn(cache));
      return cache;
    }).catch(() => { pending = null; return cache || { items: [], current: getWorkspace() }; });
  }
  return pending;
}

export function useWorkspaces() {
  const [data, setData] = useState(cache);
  useEffect(() => {
    listeners.add(setData);
    loadWorkspaces().then(setData);
    return () => listeners.delete(setData);
  }, []);
  const items = data?.items || [];
  const current = getWorkspace();
  return { items, current, active: items.find((w) => w.id === current), others: items.filter((w) => w.id !== current), reload: () => loadWorkspaces(true) };
}
